const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '2pg·com',
  url: 'https://2pg.com',
  logo: 'https://2pg.com/logo.png',
  description: '简单快捷的在线游戏娱乐平台，手机/邮箱一键注册，安全加密保障，立即开户畅享海量游戏与专属福利。',
  sameAs: [],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: '客户服务',
    email: 'support@2pg.com',
    availableLanguage: ['Chinese'],
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '2pg·com登录注册 - 快速开户立即畅玩',
  url: 'https://2pg.com',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://2pg.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const homePageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '2pg·com登录注册 - 快速开户立即畅玩 | 2pg平台官网',
  url: 'https://2pg.com',
  description: '2pg·com 登录注册流程简单快捷，支持手机/邮箱一键注册，老用户秒速登录，安全加密保障账户安全。',
  isPartOf: {
    '@type': 'WebSite',
    name: '2pg·com',
    url: 'https://2pg.com',
  },
  mainEntity: {
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '2pg·com 如何注册新账号？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过手机号或邮箱进行注册。在首页点击"立即注册"按钮，输入您的手机号或邮箱地址，设置登录密码，接收并输入验证码后即可完成注册。整个流程约需30秒，方便快捷。',
        },
      },
      {
        '@type': 'Question',
        name: '注册后可以享受哪些新人福利？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '新用户注册成功后，可立即领取专属新人礼包，包含首充优惠券、免费游戏次数、以及VIP体验资格。此外，完成实名认证还可获得额外的安全奖励金。',
        },
      },
      {
        '@type': 'Question',
        name: '平台支持哪些登录方式？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '2pg·com 支持手机号登录、邮箱登录以及账号密码登录三种方式。老用户可以选择"记住密码"功能，下次访问时实现一键快速登录。所有登录方式均经过安全加密保护。',
        },
      },
      {
        '@type': 'Question',
        name: '如何保障我的账户安全？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '平台采用256位SSL/TLS加密传输、多重身份验证、异常登录检测、以及资金独立托管等多重安全防护措施。建议您设置强密码并定期更换，同时开启登录保护功能以增强账户安全性。',
        },
      },
    ],
  },
};

export const homeSchemas = [organizationSchema, websiteSchema, homePageSchema];